import {
  IconTitleDescriptionActionCard,
  SectionContainerBase,
  TwoColumnSectionBase,
  CenteredGridBase,
} from "@reusejs/react";
import Financial1 from "../../Icons/Financial1";
import Financial2 from "../../Icons/Financial2";
import Financial3 from "../../Icons/Financial3";
import Financial4 from "../../Icons/Financial4";

let sectionHeader = {
  title: "Connecting Bidders & Financial Institutions",
  description: "",
};

const Icon = (props: any) => {
  return <div className="p-4 rounded-xl bg-blue-100">{props.iconObject}</div>;
};

let expertsCardsItems = [
  {
    icon: <Icon iconObject={<Financial1 />} />,
    name: "E-Marketplace for NPA’s",
    description:
      "We provide a transparent platform for banks and housing finance companies to list their NPAs and find potential bidders without intermediaries.",
  },
  {
    icon: <Icon iconObject={<Financial2 />} />,
    name: "Financing Support for potential bidders",
    description:
      "If bidders need financial support to pay for their bid properties, we help them by giving them holistic support in bidding and acquiring the property of their choice.",
  },
  {
    icon: <Icon iconObject={<Financial3 />} />,
    name: "Easy to use interface",
    description:
      "The process of listing properties and bidding is easy to follow, and we offer complete guidance for a smooth experience on the platform.",
  },
  {
    icon: <Icon iconObject={<Financial4 />} />,
    name: "E-Consulting",
    description:
      "Our Expert teams are available virtually for assistance on chat/phone to ensure that bidders don’t face any hiccups throughout their journey. ",
  },
];

export default function FinancialInstitutions(props: any) {
  const bgColor = props.bgColor ? props.bgColor : "";
  return (
    <SectionContainerBase
      sectionContainerBaseClasses={{
        outerContainerStyles: `py-10 md:py-16 ${bgColor}`,
        innerContainerStyles: "max-w-7xl mx-auto px-4 md:px-6 lg:px-8 xl:px-0",
      }}
    >
      <IconTitleDescriptionActionCard
        title={sectionHeader.title}
        description={sectionHeader.description}
        itemTitleDescriptionCardBaseClasses={{
          wrapper: "relative",
          titleWrapper: "text-left max-w-xl",
          titleStyles:
            "text-xl md:text-3xl font-extrabold text-gray-900 md:leading-none md:tracking-tight lg:text-4xl",
          descriptionWrapper: "text-left mt-4",
          descriptionStyles: "max-w-xl text-base text-gray-500",
        }}
      />
      <CenteredGridBase
        itemsRenderer={() => (
          <ExpertsCardComponent
            items={expertsCardsItems}
            pageWiseHeadingColor={props.pageWiseHeadingColor}
            pageWiseDescriptionColor={props.pageWiseDescriptionColor}
            cardBgColor={props.cardBgColor ? props.cardBgColor : ""}
          />
        )}
        centeredGridBaseClasses={{
          gridClasses:
            "space-y-10 sm:space-y-0 sm:grid sm:grid-cols-2 lg:grid-cols-4 sm:gap-x-8 sm:gap-y-10",
        }}
      />
    </SectionContainerBase>
  );
}

const ExpertImgComponent = (props: any) => {
  return <div>{props.expertImg}</div>;
};

const ExpertDetailComponent = (props: any) => {
  return (
    <div className="flex flex-col gap-y-1.5">
      <div className="text-lg font-bold md:text-xl md:font-semibold leading-7">
        {props.expert.name}
      </div>

      <div className="text-sm md:text-base text-gray-400 font-light">
        {props.expert.description}
      </div>
    </div>
  );
};

const ExpertsCardComponent = (props?: any) => {
  const cardBgColor = props.cardBgColor ? props.cardBgColor : "bg-gray-50";
  return (
    <>
      {props.items.map((item?: any, index?: number) => {
        return (
          <TwoColumnSectionBase
            key={index}
            firstColumnEl={<ExpertImgComponent expertImg={item.icon} />}
            secondColumnEl={<ExpertDetailComponent expert={item} />}
            twoColumnSectionBaseClasses={{
              firstElWrapperStyles: "w-full flex justify-start pb-2",
              secondElWrapperStyles: "w-full self-stretch pt-4 md:pt-16 pb-6",
              columnsFlexWrapperStyles: `flex h-full items-center flex-col rounded-lg p-5 ${cardBgColor}`,
            }}
          />
        );
      })}
    </>
  );
};
